import React from "react";

function GetCollege({college}) {
  let co = (college)? college: 0;
  let c ="";
  switch (co) {
    case 1: {
      c = "طب الأسنان";
      break;
    }
    case 2: {
      c = "الصيدلة";
      break;
    }
    case 3: {
      c = "العلوم االإدارية والمالية";
      break;
    }
    case 4: {
      c = "الهندسة";
      break;
    }
    case 5: {
      c = "الهندسة المدنية";
      break;
    }
    case 6: {
      c = "هندسة العمارة والتخطيط العمراني";
      break;
    }
    default:
      c = "طب الأسنان";
  }
  return <h3> الكلية: {c}</h3>;
}
export default GetCollege;

function getCollege(college) {
  let co = (college)? college: 0;
  let c ="";
  switch (co) {
    case 1: {
      c = "طب الأسنان";
      break;
    }
    case 2: {
      c = "الصيدلة";
      break;
    }
    case 3: {
      c = "العلوم االإدارية والمالية";
      break;
    }
    case 4: {
      c = "الهندسة";
      break;
    }
    case 5: {
      c = "الهندسة المدنية";
      break;
    }
    case 6: {
      c = "هندسة العمارة والتخطيط العمراني";
      break;
    }
    default:
      c = "طب الأسنان";
  }
  return c;
}
export  {getCollege};
